// extracted by mini-css-extract-plugin
module.exports = {"label-box-wrapper":"LabelBoxWrapper_label-box-wrapper__W3UOy","label-box-label":"LabelBoxWrapper_label-box-label__WKtKn"};